import { FileMinusIcon, FilePlusIcon } from "lucide-react";
import * as React from "react";
import { Item } from "@/types/fse";
import { Button } from "@/components/ui/button";
import { FilesSelectTree } from "@/components/app/files-select-tree";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

interface Props {
  selectedFiles: Item[];
  setSelectedFiles: React.Dispatch<React.SetStateAction<Item[]>>;
  setStep: React.Dispatch<React.SetStateAction<1 | 2>>;
  handleClose: () => void;
}

export const AddGroupModalContentStep1: React.FC<Props> = ({
  handleClose,
  setStep,
  setSelectedFiles,
  selectedFiles,
}) => {
  const user = useAuthenticatedUser();
  const handleNextStep = () => {
    setStep(2);
  };

  const handleFileAction = async (item: Item) => {
    if (selectedFiles.includes(item)) {
      setSelectedFiles(prev => prev.filter(row => row.id !== item.id));
    } else {
      setSelectedFiles(prev => [...prev, item]);
    }
  };

  return (
    <>
      <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
        <FilesSelectTree
          onAction={handleFileAction}
          actionButton={(item: Item) => (
            <Button
              variant="secondary"
              size="sm"
              className="w-full text-xs sm:w-auto"
              type="button"
              disabled={!item.permissions.some(row => row.user_id === user.id && row.role === "owner")}
            >
              {selectedFiles.includes(item) ? (
                <FileMinusIcon className="mr-1 h-4 w-4" />
              ) : (
                <FilePlusIcon className="mr-1 h-4 w-4" />
              )}
              {selectedFiles.includes(item) ? "Remove" : "Add file"}
            </Button>
          )}
          showFiles={true}
          showFolders={true}
        />
      </div>
      <div className="mt-4 flex justify-between">
        <Button type="button" variant="outline" onClick={handleClose}>
          Cancel
        </Button>

        <Button variant="default" onClick={handleNextStep} disabled={!selectedFiles.length}>
          Create Group
        </Button>
      </div>
    </>
  );
};
